import { useState } from "react";
import bellRing from "./../../img/bell-ring.svg";
import bell from "./../../img/bell.svg";

const imgSize = "30px";
const buttonSize = "40px";

export function NotificationButton() {
  const [on, setOn] = useState(false);

  return (
    <button
      onClick={() => setOn((on) => !on)}
      className="cargo-case-notification-button"
    >
      {on ? (
        <img
          width={imgSize}
          height={imgSize}
          src={bellRing}
          alt="Notification turned on"
        />
      ) : (
        <img
          width={imgSize}
          height={imgSize}
          src={bell}
          alt="Notification turned off"
        />
      )}
    </button>
  );
}
